import { PaginatorResult } from '~/api';
import { buildModule, createFiltersModule, createPaginationModule, defineSingleFilter } from '../utils';

import detail from './detail';
import lazy from './lazy';

export default buildModule()
	.withSubmodules({
		detail,
		lazy,
		list: buildModule()
			.withSubmodules({
				pagination: createPaginationModule({
					itemCountGetter: 'promos/totalCount',
				}),
				filters: createFiltersModule({
					filters: {
						categoryUuid: defineSingleFilter('categoryUuid', String),
						title: defineSingleFilter('title', String),
					},
				}),
			}),
	})
	.withState({
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	});
